var _path, _rect, _rect2, _rect3, _rect4, _rect5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconMonitorPresenters = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 120,
    viewBox: "0 0 121 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.001 102.977V92.9766H22.0397C19.5139 92.9766 17.376 92.1016 15.626 90.3516C13.876 88.6016 13.001 86.4636 13.001 83.9378V27.0153C13.001 24.4895 13.876 22.3516 15.626 20.6016C17.376 18.8516 19.5139 17.9766 22.0397 17.9766H98.9622C101.488 17.9766 103.626 18.8516 105.376 20.6016C107.126 22.3516 108.001 24.4895 108.001 27.0153V83.9378C108.001 86.4636 107.126 88.6016 105.376 90.3516C103.626 92.1016 101.488 92.9766 98.9622 92.9766H78.001V102.977H43.001ZM22.0397 85.4766H98.9622C99.3472 85.4766 99.6997 85.3162 100.02 84.9953C100.341 84.6753 100.501 84.3228 100.501 83.9378V27.0153C100.501 26.6303 100.341 26.2778 100.02 25.9578C99.6997 25.637 99.3472 25.4766 98.9622 25.4766H22.0397C21.6547 25.4766 21.3022 25.637 20.9822 25.9578C20.6614 26.2778 20.501 26.6303 20.501 27.0153V83.9378C20.501 84.3228 20.6614 84.6753 20.9822 84.9953C21.3022 85.3162 21.6547 85.4766 22.0397 85.4766Z",
    fill: "#E5E4EC"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 28.7549,
    y: 34.7656,
    width: 41.9048,
    height: 27.9365,
    fill: "#E5E4EC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 77.0078,
    y: 34.7656,
    width: 17.1429,
    height: 41.9048,
    fill: "#E5E4EC"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 28.7549,
    y: 68.4141,
    width: 10.7937,
    height: 8.25397,
    fill: "#E5E4EC"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 43.9922,
    y: 68.4141,
    width: 11.4286,
    height: 8.25397,
    fill: "#E5E4EC"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 59.8652,
    y: 68.4141,
    width: 10.7937,
    height: 8.25397,
    fill: "#E5E4EC"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconMonitorPresenters);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-monitor-presenters.731d934edaeab33f20db46f12d00dd60.svg";